import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Stack from "@mui/material/Stack"
import React from "react"
import {
  useAddTimeSlotsMutation,
  useGetSelectTimeSlotsQuery,
} from "../../../api/TimeSlotsApi"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import IconButton from "@mui/material/IconButton"
import WatchLaterIcon from "@mui/icons-material/WatchLater"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import ClearIcon from "@mui/icons-material/Clear"
import { TimePicker } from "@mui/x-date-pickers/TimePicker"
import { useForm, useFieldArray, SubmitHandler } from "react-hook-form"
import { ICreateTimeSlotsArray } from "../../../model/create/CreateTimeSlots"
import dayjs, { Dayjs } from "dayjs"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { Grid } from "@mui/material"

interface CreateTimeSlotsProps {
  open: any
  setOpen: any
}

const CreateTimeSlots: React.FC<CreateTimeSlotsProps> = ({ open, setOpen }) => {

  const timeSlotsSelects = useGetSelectTimeSlotsQuery()

  const {
    control,
    handleSubmit,
    register,
    formState,
    setValue,
    watch,
    clearErrors,
    reset,
  } = useForm<ICreateTimeSlotsArray>({
    defaultValues: {
      user: {
        userId: null,
        fullName: null,
      },
      timeSlots: [
        {
          timeline: {
            date: null,
            slots: {
              type: {
                id: null,
                name: null,
              },
              startDate: null,
              endDate: null,
            },
          },
        },
      ],
    },
  })

  const { fields, append, remove } = useFieldArray({
    control,
    name: "timeSlots",
  })

  const [addTimeSlots] = useAddTimeSlotsMutation()
  const onSubmit: SubmitHandler<ICreateTimeSlotsArray> = async (data) => {
    try {
      const response = await addTimeSlots(data)

      setOpen({ ...open, openTimeSlots: false })
      reset()
      console.log(response)
    } catch (error) {
      reset()
      console.error("Error adding interview:", error)
    }
  }

  const { errors } = formState

  return (
    <Dialog
      maxWidth={"lg"}
      open={open.openTimeSlots}
      keepMounted
      onClose={() => setOpen({ ...open, openTimeSlots: false })}
      sx={{
        ".MuiDialogContent-root": { px: "38px" },
        ".MuiDialogActions-root": {
          pb: "38px",
          px: "38px",
          maxWidth: "946px",
        },
        ".MuiDialogTitle-root": {
          px: "43px",
          pt: "38px",
        },
        ".MuiDialog-paper": {
          maxWidth: "956px",
        },
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle sx={{ fontWeight: "bold" }}>
          {"Добавление слотов"}
        </DialogTitle>
        <DialogContent>
          <Stack direction={"column"} spacing={"5px"} sx={{ mx: "5px" }}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              ФИО собеседующего *
            </Typography>
            <TextField
              size="small"
              placeholder="ФИО собеседующего"
              {...register(`user.userId`, {
                required: "Это поле обязательно для заполнения",
              })}
              error={Boolean(errors.user?.userId)}
              fullWidth
              sx={{ maxWidth: "860px" }}
              value={watch("user.userId")}
              select
            >
              {timeSlotsSelects?.data?.interviwer?.map((option: any) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Stack>
          <Grid
            alignItems={"center"}
            container
            direction={"row"}
            sx={{ mt: "5px", width: "100%" }}
          >
            {fields?.map((_, index) => (
              <Grid
                item
                key={index}
                sx={{
                  width: "280px",
                  height: "190px",
                  border: "1px solid #DCDCDC",
                  borderRadius: "4px",
                  px: "15px",
                  py: "10px",
                  m: "5px",
                  mt: "5px",
                }}
                direction={"column"}
                spacing={"10px"}
              >
                <Stack
                  direction="row"
                  justifyContent={"space-between"}
                  width="100%"
                  alignItems={"center"}
                >
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: "bold",
                      color: "primary.main",
                    }}
                  ></Typography>
                  <DatePicker
                    value={dayjs(watch(`timeSlots.${index}.timeline.date`))}
                    format="DD.MM.YYYY"
                    sx={{
                      ml: "-50px",
                      "& fieldset": {
                        border: errors?.timeSlots?.[index]?.timeline?.date
                          ?.message
                          ? "1px solid red"
                          : "none",
                      },
                      ".MuiOutlinedInput-root": {
                        fontSize: "20px",
                        color: "primary.main",
                      },
                      width: "77%",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() &&
                        clearErrors(`timeSlots.${index}.timeline.date`)
                      setValue(
                        `timeSlots.${index}.timeline.date`,
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                      )
                    }}
                    localeText={{
                      toolbarTitle: "ДД.ММ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    slotProps={{
                      textField: {
                        inputProps: register(
                          `timeSlots.${index}.timeline.date`,
                          {
                            required: "Это поле обязательно для заполнения",
                          },
                        ),

                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",

                        error: Boolean(
                          errors?.timeSlots?.[index]?.timeline?.date?.message,
                        ),
                      },
                    }}
                    minDate={dayjs()}
                  />

                  {fields.length > 1 ? (
                    <IconButton
                      onClick={() => remove(index)}
                      aria-label="delete"
                      sx={{
                        color: "rgba(23, 23, 23, 0.2)",
                        width: "40px",
                        height: "40px",
                        mr: "-10px",
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  ) : (
                    <Box sx={{ width: "40px", mr: "-10px" }}></Box>
                  )}
                </Stack>
                <Stack direction={"column"}>
                  <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                    Тип собеседования
                  </Typography>
                  {/* <Autocomplete
                    fullWidth
                    size="small"
                    disablePortal
                    options={timeSlotsSelects.data?.interviwerType}
                    getOptionLabel={(option: any) => option?.name}
                    getOptionSelected={(option: any, value: any) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        value={watch(
                          `timeSlots.${index}.timeline.slots.type.id`,
                        )}
                        {...params}
                        {...register(
                          `timeSlots.${index}.timeline.slots.type.id`,
                          {
                            required: "Это поле обязательно для заполнения",
                          },
                        )}
                        error={
                          errors?.timeSlots?.[index]?.timeline?.slots?.type?.id
                            ?.message
                        }
                        placeholder="Тип собеседования"
                      />
                    )}
                  /> */}
                  <TextField
                    size="small"
                    label="Тип собеседования"
                    inputProps={register(
                      `timeSlots.${index}.timeline.slots.type.id`,
                      {
                        required: "Это поле обязательно для заполнения",
                      },
                    )}
                    fullWidth
                    value={watch(`timeSlots.${index}.timeline.slots.type.id`)}
                    id="outlined-select-currency"
                    select
                    //@ts-ignore
                    error={Boolean(
                      errors?.timeSlots?.[index]?.timeline?.slots?.type,
                    )}
                  >
                    {timeSlotsSelects.data?.interviwerType.map(
                      (option: any) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ),
                    )}
                  </TextField>
                </Stack>
                <Stack direction={"column"}>
                  <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                    Время по МСК
                  </Typography>
                  <Stack
                    alignItems={"center"}
                    justifyContent={"center"}
                    direction={"row"}
                    spacing={"5px"}
                  >
                    <TimePicker
                      slots={{
                        openPickerIcon: WatchLaterIcon,
                      }}
                      sx={{
                        ".MuiIconButton-root": {
                          color: "rgba(139, 139, 139, 1)",
                        },
                      }}
                      value={
                        dayjs(
                          watch(`timeSlots.${index}.timeline.slots.startDate`),
                        ) || null
                      }
                      localeText={{
                        toolbarTitle: "ЧЧ.ММ",
                        fieldHoursPlaceholder: () => "ЧЧ",
                        fieldMinutesPlaceholder: () => "ММ",
                      }}
                      onChange={(e: Dayjs | null) => {
                        dayjs(e).isValid() &&
                          clearErrors(
                            `timeSlots.${index}.timeline.slots.startDate`,
                          )
                        setValue(
                          `timeSlots.${index}.timeline.slots.startDate`,
                          dayjs(e).format("DD.MM.YYYY HH:mm"),
                        )
                      }}
                      format="HH:mm"
                      slotProps={{
                        textField: {
                          inputProps: register(
                            `timeSlots.${index}.timeline.slots.startDate`,
                            {
                              required: "Это поле обязательно для заполнения",
                            },
                          ),

                          size: "small",
                          variant: "outlined",
                          placeholder: "ЧЧ.ММ",
                          fullWidth: true,
                          error: Boolean(
                            errors?.timeSlots?.[index]?.timeline?.slots
                              ?.startDate?.message,
                          ),
                        },
                      }}
                    />
                    <div
                      style={{
                        width: "10px",
                        height: "1px",
                        background: "#CACACA",
                        borderRadius: 4,
                      }}
                    />
                    <TimePicker
                      slots={{
                        openPickerIcon: WatchLaterIcon,
                      }}
                      sx={{
                        ".MuiIconButton-root": {
                          color: "rgba(139, 139, 139, 1)",
                        },
                      }}
                      value={
                        dayjs(
                          watch(`timeSlots.${index}.timeline.slots.endDate`),
                        ) || null
                      }
                      localeText={{
                        toolbarTitle: "ЧЧ.ММ",
                        fieldHoursPlaceholder: () => "ЧЧ",
                        fieldMinutesPlaceholder: () => "ММ",
                      }}
                      onChange={(e: Dayjs | null) => {
                        dayjs(e).isValid() &&
                          clearErrors(
                            `timeSlots.${index}.timeline.slots.endDate`,
                          )
                        setValue(
                          `timeSlots.${index}.timeline.slots.endDate`,
                          dayjs(e).format("DD.MM.YYYY HH:mm"),
                        )
                      }}
                      format="HH:mm"
                      slotProps={{
                        textField: {
                          inputProps: register(
                            `timeSlots.${index}.timeline.slots.endDate`,
                            {
                              required: "Это поле обязательно для заполнения",
                            },
                          ),

                          size: "small",
                          variant: "outlined",
                          placeholder: "ЧЧ.ММ",
                          fullWidth: true,
                          error: Boolean(
                            errors?.timeSlots?.[index]?.timeline?.slots?.endDate
                              ?.message,
                          ),
                        },
                      }}
                    />
                  </Stack>
                </Stack>
              </Grid>
            ))}
            {/* </Grid> */}

            {fields.length < 9 && (
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={() =>
                    append({
                      timeline: {
                        date: null,
                        slots: {
                          startDate: null,
                          endDate: null,
                          type: {
                            id: null,
                            name: null,
                          },
                        },
                      },
                    })
                  }
                  sx={{ width: "280px", height: "190px", m: "5px", mt: "5px" }}
                >
                  <Stack
                    direction={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                      Добавление слота
                    </Typography>
                    <AddCircleOutlineIcon
                      sx={{
                        color: "primary.main",
                        height: "50px",
                        width: "50px",
                        mt: "20px",
                      }}
                    />
                  </Stack>
                </Button>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Stack
            sx={{ px: "5px" }}
            direction={"column"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Stack sx={{ width: "860px" }} direction="row" spacing={"20px"}>
              <Button
                fullWidth
                size="large"
                sx={{ fontWeight: "bold" }}
                variant="outlined"
                onClick={() => setOpen({ ...open, openTimeSlots: false })}
              >
                Отмена
              </Button>
              <Button
                fullWidth
                size="large"
                sx={{ fontWeight: "bold" }}
                variant="contained"
                type="submit"
              >
                Добавить
              </Button>
            </Stack>
          </Stack>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreateTimeSlots
